import { Component } from '@angular/core';
import { Card } from 'primeng/card';
import { Button } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-billing',
  standalone: true,
  imports: [Card, Button, TranslocoModule],
  template: `
    <div class="flex items-center justify-center min-h-[calc(100vh-120px)] p-4 bg-surface-50 dark:bg-surface-950">
      <p-card styleClass="w-full max-w-lg shadow-xl border border-surface-200 dark:border-surface-800 transition-all duration-300 hover:shadow-2xl">
        <div class="flex flex-col items-center text-center p-6 sm:p-8">
          <!-- Premium Badge with Glow -->
          <div class="relative flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-tr from-primary-500 to-indigo-500 text-white shadow-lg shadow-primary-500/20 mb-8 animate-pulse-subtle">
            <i class="pi pi-credit-card text-4xl"></i>
            <div class="absolute inset-0 rounded-full bg-gradient-to-tr from-primary-500 to-indigo-500 opacity-20 blur-md -z-10"></div>
          </div>

          <!-- Header & Subtitle -->
          <h2 class="text-3xl font-bold text-surface-900 dark:text-surface-0 mb-3 tracking-tight">
            {{ 'Billing' | transloco }}
          </h2>
          <p class="text-surface-600 dark:text-surface-400 mb-8 max-w-md leading-relaxed text-lg">
            {{ 'To manage your subscription, view invoices, or update your payment details, please visit our secure billing portal.' | transloco }}
          </p>

          <!-- Action Button -->
          <p-button 
            [label]="'Click for payment page' | transloco" 
            icon="pi pi-external-link" 
            size="large"
            styleClass="w-full sm:w-auto px-8 py-4 text-lg font-semibold rounded-xl bg-gradient-to-r from-primary-600 to-indigo-600 hover:from-primary-700 hover:to-indigo-700 text-white border-none shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
            (click)="openPaymentPage()"
          />
          
          <!-- Safe Badge -->
          <div class="flex items-center gap-2 mt-6 text-sm text-surface-500 dark:text-surface-400">
            <i class="pi pi-shield text-green-500"></i>
            <span>{{ 'Secured by Grow.link' | transloco }}</span>
          </div>
        </div>
      </p-card>
    </div>
  `,
  styles: [`
    @keyframes pulse-subtle {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.03); opacity: 0.95; }
    }
    .animate-pulse-subtle {
      animation: pulse-subtle 3s infinite ease-in-out;
    }
  `]
})
export class BillingComponent {
  openPaymentPage() {
    const url = 'https://pay.grow.link/MTAwODUy~2c8c92c883ee2f187e83e1755ed6e0fd-MzQ0ODExNA';
    const windowFeatures = 'noopener,noreferrer,width=1000,height=800,scrollbars=yes,resizable=yes';
    window.open(url, '_blank', windowFeatures);
  }
}
